export default class TextArea {
  constructor(props) {
    this.input = document.querySelector('.search');
    this.cursorPosition = this.input.selectionStart;
    this.arr = this.input.value.split('');
    this.props = props;
  }

  inputKey(key) {
    const funcInput = this.props;
    if (key.length === 1) {
      this.arr.splice(this.input.selectionStart, 0, key);
      this.input.value = this.arr.join('');
      this.input.selectionStart = this.cursorPosition + 1;
      this.input.selectionEnd = this.cursorPosition + 1;
      funcInput(this.input.value);
    }
    switch (key) {
      case 'Backspace':
        this.arr.splice(this.input.selectionStart - 1, 1);
        this.input.value = this.arr.join('');
        this.input.selectionStart = this.cursorPosition - 1;
        this.input.selectionEnd = this.cursorPosition - 1;
        break;
      case 'Del':
        this.arr.splice(this.input.selectionStart, 1);
        this.input.value = this.arr.join('');
        this.input.selectionStart = this.cursorPosition;
        this.input.selectionEnd = this.cursorPosition;
        break;
      case 'Enter':
        break;
      case '':
        this.arr.splice(this.input.selectionStart, 0, ' ');
        this.input.value = this.arr.join('');
        this.input.selectionStart = this.cursorPosition + 1;
        this.input.selectionEnd = this.cursorPosition + 1;
        break;
      case 'Tab':
        this.arr.splice(this.input.selectionStart, 0, '    ');
        this.input.value = this.arr.join('');
        this.input.selectionStart = this.cursorPosition + 4;
        this.input.selectionEnd = this.cursorPosition + 4;
        break;
      default:
        break;
    }
    this.input.focus();
  }

  changeCursorPosition(arrow) {
    this.left = this.input.selectionStart - 1;
    this.right = this.input.selectionStart + 1;
    switch (arrow) {
      case 'ArrowLeft':
        this.input.selectionStart = this.left;
        this.input.selectionEnd = this.left;
        break;
      case 'ArrowRight':
        this.input.selectionStart = this.right;
        this.input.selectionEnd = this.right;
        break;
      default:
        break;
    }
    this.input.focus();
  }
}
